export const FEATURE_NAME = '@vshapps/libs/dialog';
